import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers.jsx";
export const store = configureStore({
  reducer: {
    user: userReducer,
  },
});
